/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Genres_Meta_TitleInputs */

const id_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre - egdata.app`)
};

const ms_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre - egdata.app`)
};

const da_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer - egdata.app`)
};

const de_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres - egdata.app`)
};

const en_us2_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres - egdata.app`)
};

const es_es2_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros - egdata.app`)
};

const es_mx2_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros - egdata.app`)
};

const fil_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Genre - egdata.app`)
};

const fr_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres - egdata.app`)
};

const it_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generi - egdata.app`)
};

const hu_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfajok - egdata.app`)
};

const nl_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres - egdata.app`)
};

const no_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjangre - egdata.app`)
};

const pl_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunki - egdata.app`)
};

const pt_br2_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gêneros - egdata.app`)
};

const pt_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros - egdata.app`)
};

const ro_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genuri - egdata.app`)
};

const fi_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityypit - egdata.app`)
};

const sv_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer - egdata.app`)
};

const vi_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại - egdata.app`)
};

const tr_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türler - egdata.app`)
};

const cs_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánry - egdata.app`)
};

const bg_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанрове - egdata.app`)
};

const ru_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанры — egdata.app`)
};

const uk_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанри - egdata.app`)
};

const ar_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأنواع - egdata.app`)
};

const hi_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैलियाँ - egdata.app`)
};

const th_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนวเกม - egdata.app`)
};

const ja_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル - egdata.app`)
};

const zh_cn2_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型 - egdata.app`)
};

const zh_hant1_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型 - egdata.app`)
};

const ko_genres_meta_title = /** @type {(inputs: Genres_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장르 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Genres - egdata.app" |
*
* @param {Genres_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const genres_meta_title = /** @type {((inputs?: Genres_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Genres_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_genres_meta_title(inputs)
	if (locale === "ms") return ms_genres_meta_title(inputs)
	if (locale === "da") return da_genres_meta_title(inputs)
	if (locale === "de") return de_genres_meta_title(inputs)
	if (locale === "en-US") return en_us2_genres_meta_title(inputs)
	if (locale === "es-ES") return es_es2_genres_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_genres_meta_title(inputs)
	if (locale === "fil") return fil_genres_meta_title(inputs)
	if (locale === "fr") return fr_genres_meta_title(inputs)
	if (locale === "it") return it_genres_meta_title(inputs)
	if (locale === "hu") return hu_genres_meta_title(inputs)
	if (locale === "nl") return nl_genres_meta_title(inputs)
	if (locale === "no") return no_genres_meta_title(inputs)
	if (locale === "pl") return pl_genres_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_genres_meta_title(inputs)
	if (locale === "pt") return pt_genres_meta_title(inputs)
	if (locale === "ro") return ro_genres_meta_title(inputs)
	if (locale === "fi") return fi_genres_meta_title(inputs)
	if (locale === "sv") return sv_genres_meta_title(inputs)
	if (locale === "vi") return vi_genres_meta_title(inputs)
	if (locale === "tr") return tr_genres_meta_title(inputs)
	if (locale === "cs") return cs_genres_meta_title(inputs)
	if (locale === "bg") return bg_genres_meta_title(inputs)
	if (locale === "ru") return ru_genres_meta_title(inputs)
	if (locale === "uk") return uk_genres_meta_title(inputs)
	if (locale === "ar") return ar_genres_meta_title(inputs)
	if (locale === "hi") return hi_genres_meta_title(inputs)
	if (locale === "th") return th_genres_meta_title(inputs)
	if (locale === "ja") return ja_genres_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_genres_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_genres_meta_title(inputs)
	return ko_genres_meta_title(inputs)
});
export { genres_meta_title as "genres.meta.title" }